import { render, staticRenderFns } from "./userDashboardSearch.vue?vue&type=template&id=67c338da&scoped=true"
import script from "./userDashboardSearch.vue?vue&type=script&lang=js"
export * from "./userDashboardSearch.vue?vue&type=script&lang=js"
import style0 from "./userDashboardSearch.vue?vue&type=style&index=0&id=67c338da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c338da",
  null
  
)

export default component.exports